<template>
  <v-app class="billing-page">
    <div class="billing-wrapper">
      <div class="billing-content">
        <billing-header class="billing-header" />

        <h1 class="mb-13">
          {{ $t('pages.billing.title') }}
        </h1>

        <current-subscription class="mb-10" />

        <payment-method class="mb-10" />

        <billing-history />
      </div>
    </div>

    <!-- Dialog Expired FreeTrial -->
    <dialog-expired-free-trial
      :visible="dialogExpiredFreeTrial"
      @close="dialogExpiredFreeTrial = false"
    />
    <!-- /Dialog Expired FreeTrial -->
  </v-app>
</template>

<script>
import BillingHeader from '@/views/Billing/Components/BillingHeader.vue'
import BillingHistory from '@/views/Billing/Components/BillingHistory.vue'
import CurrentSubscription from '@/views/Billing/Components/CurrentSubscription.vue'
import DialogExpiredFreeTrial from '@/views/Home/Components/Dialogs/DialogExpiredFreeTrial.vue'
import PaymentMethod from '@/views/Billing/Components/PaymentMethod.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BillingPage',

  components: {
    PaymentMethod,
    BillingHeader,
    BillingHistory,
    CurrentSubscription,
    DialogExpiredFreeTrial
  },

  data () {
    return {
      dialogExpiredFreeTrial: false
    }
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn'])
  },

  mounted () {
    if (!this.$store.state.user.subscribed && this.isLoggedIn) {
      this.dialogExpiredFreeTrial = true
    }
  }
}
</script>

<style scoped lang="scss">
.billing-page {
  background-color: #F5F6FA !important;
  padding: 0 0 80px 0;

  .billing-wrapper {
    background-color: #F5F6FA;

    .billing-content {
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
      padding: 10px 20px 50px 20px;
      box-sizing: border-box;
    }

    .billing-header {
      @include media-breakpoint-up($sm) {
        margin-bottom: 86px;
      }
    }
  }
}
</style>
